// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"6060":"chunk-video","7227":"chunk-echarts"}[chunkId] || chunkId) + ".1790586976224.js";
};